// AppInsights.js (o un modulo separato)
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();
const connectionStringFromEnv = process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;
const appInsights = new ApplicationInsights({
    config: {
        connectionString: connectionStringFromEnv,
        extensions: [reactPlugin],
    }
});
appInsights.loadAppInsights();

export default reactPlugin;